import Vue from 'vue'
import { API_URL } from '../../api'
import ComponentsFilter from '../../filters/ComponentsFilter';
const state = {
    componentCreate: {
        createdComponent: null,
        creatingComponent: false,
        createComponentStatus: null
    },
    componentUpdate: {
        updatedComponent: null,
        updatingComponent: false,
        updateComponentStatus: null
    },
    componentDelete: {
        deletingComponent: false,
        deleteComponentStatus: null
    },
    componentSearch: {
        componentsCount: null,
        components: [],
        searchingComponents: false,
        searchComponentStatus: null
    },
}
const mutations = {
    ['SET_COMPONENT_CREATE'](state, change) {
        state.componentCreate = { ...state.componentCreate, ...change };
    },
    ['SET_COMPONENT_UPDATE'](state, change) {
        state.componentUpdate = { ...state.componentUpdate, ...change };
    },
    ['SET_COMPONENT_DELETE'](state, change) {
        state.componentDelete = { ...state.componentDelete, ...change };
    },
    ['SET_COMPONENT_SEARCH'](state, change) {
        state.componentSearch = { ...state.componentSearch, ...change };
    }
}
const actions = {
    createComponent: ({ commit }, payload) => {
        commit('SET_COMPONENT_CREATE', { createComponentStatus: null, createdComponent: null, creatingComponent: true })
        return Vue.http.post(API_URL + '/components/create', payload).then(response => {
            commit('SET_COMPONENT_CREATE', { createComponentStatus: 'success', createdComponent: response.body.results.component });
        }).catch(response => {
            commit('SET_COMPONENT_CREATE', { createComponentStatus: 'failed' });
        }).finally(() => {
            commit('SET_COMPONENT_CREATE', { creatingComponent: false });
        });
    },
    updateComponent: ({ commit }, payload) => {
        commit('SET_COMPONENT_UPDATE', { updateComponentStatus: null, updatedComponent: null, updatingComponent: true })
        return Vue.http.post(API_URL + '/components/update/' + payload.id, payload)
            .then(response => {
                commit('SET_COMPONENT_UPDATE', { updateComponentStatus: 'success', updatedComponent: response.body.results.component });
            })
            .catch(response => {
                commit('SET_COMPONENT_UPDATE', { updateComponentStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_COMPONENT_UPDATE', { updatingComponent: false });
            })
    },
    deleteComponent: ({ commit }, id) => {
        commit('SET_COMPONENT_DELETE', { deleteComponentStatus: null, deletedComponent: null, deletingComponent: true })
        return Vue.http.delete(API_URL + '/components/delete/' + id).then(response => {
            commit('SET_COMPONENT_DELETE', { deleteComponentStatus: 'success' });
        }).catch(response => {
            commit('SET_COMPONENT_DELETE', { deleteComponentStatus: 'failed' });
        }).finally(() => {
            commit('SET_COMPONENT_DELETE', { deletingComponent: false });
        })
    },
    searchComponents: ({ commit }, payload = { filter: ComponentsFilter(), resultMode: 'default' }) => {
        commit('SET_COMPONENT_SEARCH', { searchComponentStatus: null, searchComponent: null, searchingComponents: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/components' + params).then(response => {
            commit('SET_COMPONENT_SEARCH', { searchComponentStatus: 'success', components: response.body.results.components });
        }).catch(response => {
            commit('SET_COMPONENT_SEARCH', { searchComponentStatus: 'failed' });
        }).finally(() => {
            commit('SET_COMPONENT_SEARCH', { searchingComponents: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/componentStore.js